import React, { useState, useEffect } from 'react';
import Text from '../../components/Text.js';
import TextInput from '../../components/TextFields/TextInput.js';
import DateInput from '../../components/TextFields/DateInput.js';
import Grid from '@mui/material/Grid';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';

/**
 * @param data
 * @param errors
 * @param accessData
 * @param handleChange
 * @returns 
 */
const Authorization = ({
  data,
  errors,
  accessData,
  handleChange,
  signageSuccess = false
}) => {
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column'
    },
    sectionHeader: {
      marginTop: '25px',
      marginBottom: '10px'
    },
    text: {
      marginBottom: '20px'
    }
  };

  /**
   * Determines if the signature fields should be disabled
   * @returns { memberSignageDisabled, adminSignageDisabled}
   */
  function _isSignageDisabled() {
    let hasBeenSigned = false;
    if (accessData.isAgent) {
      return {
        memberSignageDisabled: true,
        adminSignageDisabled: true
      };
    }
    if (accessData.accessType?.toUpperCase() === 'MEMBER') {
      hasBeenSigned = data.signage.member.eSignature || signageSuccess;
      return {
        memberSignageDisabled: Boolean(hasBeenSigned || !['Pending Member Review', 'Incomplete'].includes(data.status)),
        adminSignageDisabled: true
      };
    }
    if (accessData.accessType?.toUpperCase() === 'ADMINISTRATOR') {
      hasBeenSigned = data.signage.admin.eSignature || signageSuccess;
      return {
        memberSignageDisabled: true,
        adminSignageDisabled: Boolean(hasBeenSigned || !['Pending Admin Review', 'Incomplete'].includes(data.status))
      };
    }
    return {};
  }
  const {
    memberSignageDisabled,
    adminSignageDisabled
  } = _isSignageDisabled();
  return /*#__PURE__*/React.createElement("div", {
    style: styles.container
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    medium: true,
    customStyle: styles.sectionHeader
  }, i18n.t(tokens.labels.changeRequests.authorization)), /*#__PURE__*/React.createElement(Text, {
    small: true,
    customStyle: styles.text
  }, i18n.t(tokens.labels.changeRequests.authTextOne)), /*#__PURE__*/React.createElement(Text, {
    small: true,
    customStyle: styles.text
  }, i18n.t(tokens.labels.changeRequests.authTextTwo)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, i18n.t(tokens.labels.changeRequests.authTextThree)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, i18n.t(tokens.labels.changeRequests.authTextFour)), /*#__PURE__*/React.createElement(Text, {
    small: true,
    customStyle: styles.text
  }, i18n.t(tokens.labels.changeRequests.authTextFive)), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    columnSpacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.changeRequests.memberSignature),
    value: data.signage?.member?.signature,
    onChange: event => handleChange('signature', event.target.value, 'signageMember'),
    isSignature: true,
    disabled: memberSignageDisabled,
    error: !memberSignageDisabled && errors.memberSignature,
    variant: "outlined",
    fullWidth: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(DateInput, {
    label: i18n.t(tokens.labels.changeRequests.memberDatedOn),
    value: data.signage?.member?.datedOn,
    onChange: event => handleChange('datedOn', event.target.value, 'signageMember'),
    disabled: memberSignageDisabled,
    error: !memberSignageDisabled && errors.memberDatedOn,
    variant: "outlined",
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    columnSpacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.changeRequests.planAdministratorSignature),
    value: data.signage?.admin?.signature || '',
    onChange: event => handleChange('signature', event.target.value, 'signageAdmin'),
    isSignature: true,
    disabled: adminSignageDisabled,
    error: !adminSignageDisabled && errors.AdminSignature,
    variant: "outlined",
    fullWidth: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(DateInput, {
    label: i18n.t(tokens.labels.changeRequests.planAdministratorDatedOn),
    value: data.signage?.admin?.datedOn || '',
    onChange: event => handleChange('datedOn', event.target.value, 'signageAdmin'),
    disabled: adminSignageDisabled,
    error: !adminSignageDisabled && errors.AdminDatedOn,
    variant: "outlined",
    fullWidth: true
  }))));
};
export default Authorization;